const cloudinaryConfig = {
  cloudName: 'marvel-content',
};

export default cloudinaryConfig;



// WEBPACK FOOTER //
// ./src/configs/cloudinary.js